import React from 'react';
import { BoxIcon } from 'lucide-react';
interface PageHeaderProps {
  icon: BoxIcon;
  title: string;
  subtitle: string;
  badge?: string;
  accentColor?: string;
}
export function PageHeader({
  icon: Icon,
  title,
  subtitle,
  badge,
  accentColor = 'bg-indigo-100 text-indigo-600'
}: PageHeaderProps) {
  return <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-5 mb-8" data-id="element-5102">
      <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${accentColor} shadow-sm flex-shrink-0`} data-id="element-5103">
        <Icon className="w-7 h-7" strokeWidth={2.5} data-id="element-5104" />
      </div>
      <div className="flex-1 min-w-0" data-id="element-5105">
        <div className="flex items-center gap-3 flex-wrap" data-id="element-5106">
          <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight" data-id="element-5107">
            {title}
          </h1>
          {badge && <span className="px-3 py-1 rounded-full bg-indigo-50 text-indigo-700 text-sm font-bold border border-indigo-100" data-id="element-5108">
              {badge}
            </span>}
        </div>
        <p className="text-slate-500 font-medium text-base sm:text-lg mt-1" data-id="element-5109">
          {subtitle}
        </p>
      </div>
    </div>;
}